module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "chap-num",
    attrs: {
      "id": "C1"
    }
  }, [_vm._v("1")]), _vm._v(" "), _c('p', {
    staticClass: "chap-title"
  }, [_vm._v("SEPTEMBER 16, 1903")]), _vm._v(" "), _c('div', {
    staticClass: "block"
  }, [_c('p', {
    staticClass: "block-center"
  }, [_c('i', [_vm._v("From the")]), _vm._v(" San Francisco Call")]), _vm._v(" "), _c('p', {
    staticClass: "block-center1"
  }, [_c('i', [_vm._v("“RED SHIRT” GORDON NOW IN CUSTODY")])]), _vm._v(" "), _c('p', {
    staticClass: "block-center"
  }, [_c('i', [_vm._v("Convict Is Captured—by an Officer in Texas.")])]), _vm._v(" "), _c('p', {
    staticClass: "block-center"
  }, [_c('i', [_vm._v("Desperate Leader of Convicts Is Run Down in Lone Star State.")])]), _vm._v(" "), _c('p', {
    staticClass: "block-center"
  }, [_c('i', [_vm._v("Special Dispatch to The Call.")])]), _vm._v(" "), _c('p', {
    staticClass: "block-center1"
  }, [_c('i', [_vm._v("A telegram was just received by Warden Wilkinson from W.B. Mathis, an officer in Jacksonville, Tex., conveying the information that he had in custody convict 474S, Richard M. Gordon, one of the men who escaped in the jail break of July 27, and asking the amount of the reward. There can be no question but that the Texas officer has the right man, but how he was captured is a mystery. as there are no particulars at hand.")])]), _vm._v(" "), _c('p', {
    staticClass: "block-center"
  }, [_c('i', [_vm._v("“Red Shirt” Gordon was considered to be the shrewdest and most desperate of the fugitive convicts and the authorities had but very little hope of ever recapturing him. After the convicts had succeeded in their break and had got beyond the prison grounds. Gordon, realizing that he would stand a better chance of escaping: if alone, suddenly dropped away from the crowd and was not missed for quite a while. The other convicts were very much incensed at Gordon for his doing as he did and swore vengeance on him if any of them ever chanced to meet him. His presence in Texas shows the man’s resourcefulness in getting far away from the scene of the prison break and the subsequent man hunt.")]), _c('sup', [_c('span', {
    attrs: {
      "href": "#/Note#FN2",
      "id": "FT2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])])])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("O"), _c('span', {
    staticClass: "small"
  }, [_vm._v("FFICER")]), _vm._v(" M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ATHIS")]), _vm._v("’"), _c('span', {
    staticClass: "small"
  }, [_vm._v("S")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("TELEGRAM")]), _vm._v(" "), _c('span', {
    staticClass: "small"
  }, [_vm._v("WOULD")]), _vm._v(" have put an end to the saga of one of the biggest prison breaks in United States history if Gordon had been subsequently returned to California, but he wasn’t. He was then also reported dead in Missouri several years later, but he was never returned to California.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-69f41d7a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Chapter1.vue
// module id = 84
// module chunks = 0